const require_adapter = require('./adapter.cjs');
const require_getScriptTag = require('./getScriptTag.cjs');

exports.adapter = require_adapter.default;
exports.getScriptTag = require_getScriptTag.default;